/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_WarehouseInputs */

const vi_product_stock_warehouse = /** @type {(inputs: Product_Stock_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho`)
};

/**

* @param {Product_Stock_WarehouseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_warehouse = /** @type {((inputs?: Product_Stock_WarehouseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_WarehouseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_warehouse(inputs)
});